import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";

import { MY_PROFILE_URL } from "shared/constants/apiUrls";
import {
  CONST_BILLING_POLICY,
  CONST_CONSENT_POLICY,
  CONST_COOKIE_POLICY,
  CONST_PRIVACY_POLICY,
  CONST_REFUND_POLICY,
  CONST_TERMS_OF_USE,
} from "shared/constants/legacy";

import { useCurrentCountry } from "shared/hooks/useCurrentCountry";

import "@brandAssets/scss/terms.scss";

if (import.meta.env.VITE_APP_API_HOST !== "") {
  axios.defaults.withCredentials = true;
}

const termsTitleTranslateKeys = {
  [CONST_TERMS_OF_USE]: "terms.termsOfUse",
  [CONST_REFUND_POLICY]: "terms.refundPolicy",
  [CONST_BILLING_POLICY]: "terms.billingPolicy",
  [CONST_PRIVACY_POLICY]: "terms.privacyPolicy",
  [CONST_COOKIE_POLICY]: "terms.cookiePolicy",
  [CONST_CONSENT_POLICY]: "terms.consentPolicy",
};

const layoutMap = {
  "terms-of-use": CONST_TERMS_OF_USE,
  "refund-policy": CONST_REFUND_POLICY,
  "billing-policy": CONST_BILLING_POLICY,
  "privacy-policy": CONST_PRIVACY_POLICY,
  "cookie-policy": CONST_COOKIE_POLICY,
  "consent-policy": CONST_CONSENT_POLICY,
};

export const ComponentLegacy = () => {
  const [title, setTitle] = useState("");
  const { t } = useTranslation("common");

  useCurrentCountry();

  useEffect(() => {
    Object.entries(layoutMap).forEach(([key, value]) => {
      if (window.location.pathname.includes(key)) {
        setTitle(termsTitleTranslateKeys[value]);
      }
    });
  }, []);

  useEffect(() => {
    fetch(import.meta.env.VITE_APP_API_HOST + MY_PROFILE_URL, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (data.data.uid) {
          const btn = document.querySelector(".btn-join");
          const logo = document.querySelector(".logo_wrap");

          if (btn) {
            btn.innerText = "Back to site";
            btn.addEventListener("click", (e) => {
              e.preventDefault();
              window.history.back();
            });
          }

          if (logo) {
            logo.setAttribute("href", "/app/");
          }
        }
      })
      .catch((err) => {
        console.log(err.message);

        const footer = document.querySelectorAll("[data-footer = 'footer']");
        const btn = document.querySelector(".btn-join");

        if (!err.success) {
          if (footer) {
            footer.forEach((element) => {
              element.style.display = "block";
            });
          }

          if (btn) {
            btn.setAttribute("href", "/");
          }
        }
      });
  }, []);

  return <>{t(title)}</>;
};
